module.exports = __webpack_public_path__ + "img/newFolder_black.f25d4fe9.svg";